import HomePage from '../pages/Homepage';
import Curtains from '../components/Curtains';
import About from '../pages/About';
import Retirees from '../pages/Retirees';

const Routes = [
    { path: "/", element: <HomePage/> },
    { path: "/about", element: <About/> },
    { path: "/retirees", element: <Retirees/> },
    { path: "/curtains", element: <Curtains/> },
    { path: "*", element: <h1>404 Not Found</h1> }
]

export default Routes;